<app-accordion
  title="My Sequences"
  (visibleChange)="getMonthData(0, false)"
  [visible]="true"
>
  <div class="content">
    <div class="header">
      <p-button
        icon="pi pi-chevron-left"
        [text]="true"
        severity="contrast"
        (click)="getMonthData(-1, false)"
      />
      <div class="month-label">
        {{ monthLabel }}
      </div>
      <p-button
        icon="pi pi-chevron-right"
        [text]="true"
        severity="contrast"
        (click)="getMonthData(1, false)"
      />
    </div>
    <div class="body">
      @if (sequences$ | async; as sequences) {
        @if (isLoading()) {
          <div class="sequence-state-container">
            <app-loading />
          </div>
        } @else if (sequences.length === 0) {
          <div class="sequence-state-container">
            <div class="subtext">No sequences found</div>
          </div>
        } @else {
          @for (sequence of sequences; track $index) {
            <app-sequence-card class="card" [sequence]="sequence" />
          }
        }
      }
    </div>
    <div class="footer">
      <app-last-updated
        class="width-100"
        [refreshing]="isLoading()"
        (refresh)="getMonthData(0, true)"
        [lastUpdated]="mySequenceService.lastUpdated()"
      />
    </div>
  </div>
</app-accordion>
